

export const SummaryActionTypes={
    SET_SUMMARY_MODAL_VISIBILITY:'SET_SUMMARY_MODAL_VISIBILITY'
}